import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImageJsonValue, LinkJsonValue, KeyValue } from 'src/shared/shared.types';

export interface N01HeaderProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: { [key: string]: string | undefined };
  fields?: {
    data?: {
      header?: HeaderData;
    };
  };
}

export interface HeaderData {
  mainNavigation?: {
    targetItem?: N01MainGlobalNavigation;
  };
  utilityNavigation?: {
    targetItem?: N02UtilityNavigation;
  };
}

export interface N01MainGlobalNavigation {
  logo?: {
    jsonValue?: ImageJsonValue;
    width?: number;
    height?: number;
  };
  logoImageInverse?: {
    jsonValue?: ImageJsonValue;
    width?: number;
    height?: number;
  };
  logoUrl?: {
    url?: string;
    jsonValue?: LinkJsonValue;
  };
  logoTitle?: {
    value?: string;
  };
  mobileSupportLink?: {
    jsonValue?: LinkJsonValue;
  };
  searchBarColor?: {
    targetItem?: KeyValue;
  };
  children?: {
    results?: (N01MainGlobalNavigationItem | N01MainGlobalNavigationSection)[];
  };
}

export interface N01MainGlobalNavigationItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
  };
  mobileText?: {
    value?: string;
  };
  coloredBarClass?: {
    targetItem?: KeyValue;
  };
}

export interface N01MainGlobalNavigationSection {
  displayName?: string;
  title?: {
    value?: string;
  };
  coloredBarClass?: {
    targetItem?: KeyValue;
  };
  template?: {
    id?: string;
  };
  children?: {
    results?: N01MainGlobalNavigationItem[];
  };
}

export interface N02UtilityNavigation {
  cTAButtonLink?: CTAButtonLink;
  cTAButtonLink2?: CTAButtonLink;
  highlightedMobileCTA?: {
    value?: string;
  };
  children?: {
    results?: (N02UtilityNavigationItem | N02UtilityNavigationSection)[];
  };
}

export interface N02UtilityNavigationItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  mobileText?: {
    value?: string;
  };
}

export interface N02UtilityNavigationLanguageSelectorItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  mobileText?: {
    value?: string;
  };
  spanishText?: {
    value?: string;
  };
  spanishLink?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  spanishMobileText?: {
    value?: string;
  };
}

export interface N02UtilityNavigationSection {
  displayName?: string;
  template?: {
    id?: string;
  };
  title?: {
    value?: string;
  };
  children?: {
    results?: N02UtilityNavigationItem[];
  };
}

interface CTAButtonLink {
  text?: string;
  url?: string;
  jsonValue?: LinkJsonValue;
}
